import { Avatar } from '@mui/material';
import { AuthService, useViewModel } from '@utils';
import { MeetingPlanerViewModel, ProfileViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, { FC, useMemo } from 'react';
import { HeaderMember } from './HeaderMember';

export const Header: FC = observer(() => {
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);
  const profileViewModel = useViewModel(ProfileViewModel);
  const initiatorId = AuthService.getUserId();
  const offset = useMemo(() => profileViewModel.minutesOffset, [profileViewModel.minutesOffset]);
  
  return (
    <div className="row">
      <div className="day time" />
      <div className="day member">
        <div className="photo">
          <Avatar
            sx={{ height: 26, width: 26 }}
            src={profileViewModel.profileInfo.img}
          />
        </div>
        <div className="info">
          <div className="name">
            Вы
          </div>
          <div className="position">
            {profileViewModel.profileInfo.position}
          </div>
        </div>
      </div>
      {meetingPlanerViewModel.membersValues.slice(0, 10).map((member) => (
        <HeaderMember 
        member={member} 
        offset={offset} 
        updateSelectedMembers={meetingPlanerViewModel.updateSelectedMembers} 
        initiatorId={initiatorId}/>
      ))}
    </div>
  );
});
